import { createBrowserHistory } from 'history';
import $ from 'jquery';
import * as modalUtils from '../buttons/utils/modalUtils';

const history = createBrowserHistory({
	getUserConfirmation(message, callback) {
		// Show some custom dialog to the user and call
		// callback(true) to continue the transiton, or
		// callback(false) to abort it.
		modalUtils.showLeaveModal();

		$('#stay-and-finish').click(function() {
			console.log('stay-and-finish clicked');
			modalUtils.hideLeaveModal();
			callback(false); // eslint-disable-line
		})

		$('#dismiss-leave').click(function() {
			modalUtils.hideLeaveModal();
			callback(false); // eslint-disable-line
		})

		$('#leave-now').click(function() {
			modalUtils.hideLeaveModal();
			callback(true); // eslint-disable-line
		})
	}
});
const location = history.location;

history.block((targetLocation, action) => {
  // The location and action arguments indicate the location
  // we're transitioning to and how we're getting there.
	if (window.location.pathname === '/donate/buttons/unhosted' &&
		targetLocation.pathname !== '/donate/buttons/unhosted/edit' &&
		targetLocation.pathname !== '/donate/buttons/login') {
		return 'If you leave now, your work won\'t be saved and you\'ll need to start over to create your button.';
	}
})

export {
	history,
	location
};

export default history;
